import { ButtonSetComponent } from './../button/button-set/button-set.component';
import { Component, OnInit, ViewChild, ElementRef, Output, EventEmitter, Input, ViewEncapsulation } from '@angular/core';
import { SubScriptionMgr } from 'src/app/model/SubscriptionMgr';
import { IconButtonComponent } from '../icon-button/icon-button.component';

@Component({
  selector: 'app-zoom-to-tools',
  templateUrl: './zoom-to-tools.component.html',
  styleUrls: ['./zoom-to-tools.component.scss']
})
export class ZoomToToolsComponent implements OnInit {

  @ViewChild('buttonSet', { static: true }) buttonSet:ButtonSetComponent;
  private subcriptions: SubScriptionMgr = new SubScriptionMgr();
  private selectedAction: string;
  @Input() btnSize = 'md';
  // tslint:disable-next-line: variable-name
  @Output() actions: EventEmitter<any> = new EventEmitter<any>();
  private _hasSelResults: boolean = false;
  @Input() set hasSelResults(has: boolean) {
    this._hasSelResults = has;
    console.log(this._hasSelResults);
  }
  get hasSelResults(): boolean {
    return this._hasSelResults;
  }
  @Input() hasUnselResults: boolean = false;
  @Input() hasResults: boolean = false;


  constructor(private domNode: ElementRef) { }
  UpdateHeight() {
    this.buttonSet.UpdatePosition();
  }

  ngOnInit() {

  }
  SelectTool(tool: string) {
    this.actions.emit({ zoomToToolsAction: tool });
  }

}
